import React from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';

//import axios from 'axios';

import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../Context';

import { DocumentForm } from './common/DocumentForm';


export function OrderFormUpload (){
  //const media_url = useContext(MEDIA_URL);
  let { orderId } = useParams();
  orderId = Number(orderId);

  return (
    <>
      <p className="m-3"><Link to={`/order/` + orderId}>назад к договору</Link></p>
      <div className="row">
        <h3 className="m-3">Обновить файл с бланком заказа</h3>
      </div>
      <div className="row">
        <div className="col-9">
          <>
            <div className='m-3'>
              <DocumentForm
                orderId={orderId}
                documentFilename="order_form_file" 
              />                       
            </div> 
          </>
        </div>
      </div> 
    </>
  )
}


export function ContractUpload (){
  //const media_url = useContext(MEDIA_URL);
  let { orderId } = useParams();
  orderId = Number(orderId);

  return (
    <>
      <p className="m-3"><Link to={`/order/` + orderId}>назад к договору</Link></p>
      <div className="row">
        <h3 className="m-3">Обновить файл с текстом договора</h3>
      </div>
      <div className="row">
        <div className="col-9">
          <>
            <div className='m-3'>
              <DocumentForm
                orderId={orderId}
                documentFilename="contract_file" 
              />                       
            </div> 
          </>
        </div>
      </div> 
    </>
  )
}